import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "@edaz/edazkit/Button/index";

const IdleModal: FunctionComponent<{
  translate: (code: string) => string;
  resetIdle: () => void;
  isVisible: boolean;
  remainTime: number;
}> = observer(({ translate, resetIdle, isVisible, remainTime }) => {
  const rootRef = useRef<HTMLDivElement>(null);
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const onHide = () => {};
  const secondsRegex = /%seconds%/g;
  const countRegex = /%count%/g;
  const seconds = remainTime / 1000 ?? 0;

  const inSeconds = translate(seconds < 5 && seconds > 0 ? (seconds === 1 ? "inSecond" : "in4Seconds") : "inSeconds");

  const time = translate("description").replace(secondsRegex, inSeconds.replace(countRegex, seconds.toString()));

  return (
    <div ref={rootRef}>
      <Modal container={rootRef.current} dialogClassName="loading-modal" show={isVisible} onHide={onHide} centered>
        <Modal.Body className="text-center p-7">
          <h4 className="mb-4">{translate("title")}</h4>
          <label className="mb-4 font-weight-normal">{time}</label>
          <Button variant="primary" onClick={resetIdle} size="sm" className="mt-1 pl-4 pr-4">
            {translate("continue")}
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
});

export default IdleModal;
